import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ChatIcon, FollowIcon } from "../../../../assets/icons/MUI/NetworkIcons";
import NewChatPopUp from "../../../../shared/NewChatPopUp";
import { UserActionsProps } from "../../types/props/userCardProps";
import { useFollowMutation } from "../../api/mutations/useFollowMutation";
import { useUnfollowMutation } from "../../api/mutations/useUnfollowMutation";

export const UserActions = ({
  user,
  variant,
  isFollowing,
  openCreateMessage,
  setOpenCreateMessage,
  currentLanguage,
}: UserActionsProps) => {
  const { t } = useTranslation("user", { keyPrefix: "userActions" });
  const { follow, isLoading: isFollowLoading } = useFollowMutation();
  const { unfollow, isLoading: isUnfollowLoading } = useUnfollowMutation();

  const isLoading = isFollowLoading || isUnfollowLoading;

  if (isFollowing) {
    return (
      <>
        <Button
          variant="secondary-sm"
          fullWidth={variant !== "list"}
          startIcon={currentLanguage === "en" && <ChatIcon />}
          endIcon={currentLanguage === "ar" && <ChatIcon />}
          onClick={() => setOpenCreateMessage(true)}
          sx={{
            width: variant === "list" ? "fit-content" : "100%",
            alignSelf: "end",
            ...(variant === "grid" && {
              marginTop: "14px",
            }),
          }}
        >
          {t("chat")}
        </Button>
        {/* <Button
          variant="outlined-sm"
          fullWidth={variant !== "list"}
          onClick={() => unfollow(user)}
          disabled={isLoading}
          sx={{ width: variant === "list" ? "fit-content" : "100%", alignSelf: "end", mt: 1 }}
        >
          {t("unfollow")}
        </Button> */}
        {openCreateMessage && (
          <NewChatPopUp
            open={openCreateMessage}
            handleClose={() => setOpenCreateMessage(false)}
            // @ts-expect-error User type is compatible with UserInfo for our use case
            receiverInfo={user}
          />
        )}
      </>
    );
  }

  return (
    <Button
      variant="outlined-sm"
      fullWidth={variant !== "list"}
      startIcon={currentLanguage === "en" && <FollowIcon />}
      endIcon={currentLanguage === "ar" && <FollowIcon />}
      onClick={() => follow(user)}
      disabled={isLoading}
      sx={{
        width: variant === "list" ? "fit-content" : "100%",
        alignSelf: "end",
        ...(variant === "grid" && {
          marginTop: "14px",
        }),
      }}
    >
      {t("follow")}
    </Button>
  );
};
